<template>
  <div class="vertical-offset3 bottom-offset3 inline-block width-100">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'TrDialogFooter'
};
</script>